<template>
  <div class="nx-table">
    <template v-for="(scope, index) in scopes">
      <v-flex v-if="scope.items.length > 0" :key="`${scope.scope}-${index}`" class="scope">
        <h2 class="subtitle mb-1">
          {{ $te(`message.metadata.${scope.scope}`) ? $t(`message.metadata.${scope.scope}`) : scope.scope }}
        </h2>
        <v-layout row wrap>
          <v-flex xs12 class="scope-items">
            <slot v-bind="{ scope: scope.scope, items: scope.items }">
              <template v-for="(item, index) in scope.items">
                <nx-table-item :key="`${scope}-${index}`" v-bind="isObject(item) ? item : {}" />
              </template>
            </slot>
          </v-flex>
        </v-layout>
      </v-flex>
    </template>
  </div>
</template>

<script>
import isObject from 'lodash/isObject';
import NxTableItem from '@/components/table/TableItem';

export default {
  name: 'nx-table',
  components: { NxTableItem },
  props: {
    scopes: {
      type: Array,
      default: () => ([]),
      required: true,
    },
  },
  methods: {
    isObject,
  },
};
</script>

<style lang="stylus" scoped>
.subtitle {
  color: #4e82d1;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
}

.scope {
  margin: 0 -10px;
  margin-top: 30px;
}

.scope-items {
  overflow-x: auto;
}
</style>
